import styled, { css } from "styled-components";

export const ClassBody = styled.div`
position: relative;
${(props) => (props?.steps ?
    css`
    padding-right: 20px;
    padding: 31px 40px;
      @media only screen and (min-width: 1920px) and (min-height: 1081px) {
      max-height:76vh;
      }
      `
    : css`
      padding-right:51px ;
      overflow-x: hidden;
      `

  )};

@media only screen and (max-width: 1920px) and (max-height: 1596px) {
  height: 100%;
}

`
export const Title = styled.div`
text-align: center;
`
export const ClassTitle = styled.h1`
font-style: normal;
font-weight: var(--general-page-header-font-weight);
font-size: var(--general-page-header-font-size);
line-height: 29px;
color: var(--font-color-blue002e5c);
`
export const ClassInformation = styled.h1`
font-style: normal;
font-weight: var(--general-header-font-weight);
font-size: var(--general-header-font-size);
line-height: 24px;
color: var(--font-color-blue002e5c);
text-align: left;
margin-bottom: 42px;
`

export const ClassCaption = styled.p`
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
font-family: var(--general-large-body-font-family);
font-style: normal;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 40px;
text-transform: capitalize;
color: var(--font-color-blue002e5c);
div{
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 10px;
gap: 10px;
font-size: var(--general-small-label-font-size);
font-weight: var(--font-weight-bold);
height: 24px;
background: rgba(250, 51, 114, 0.2);
border-radius: 5px;
margin-left: 8px;
color: var(--font-color-redfa3372);
}
`
export const ClassCaptionDetails = styled.div`
  display: flex;
  text-align: left;
  color:var(--font-color-blue002e5c);
  margin-bottom: 20px;
  div{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    
  }
  div:last-child{
    align-items: flex-start;
    width: 75%;  }
  span{
    font-style: normal;
    font-weight: var(--general-small-header-font-weight);
    font-size: var(--general-small-header-font-size);
}
`
export const Boxes = styled.div`
        width: revert;
         display:flex;
         justify-content:space-between;
         text-align: center;
         height: 106px;
         background: rgba(37, 85, 239, 0.04);
        border-radius: 4px;
      div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-weight: var(--general-page-header-font-weight);
        font-size: var(--general-page-header-font-size);
        line-height: 32px;
        color: var(--font-color-blue2555ef);

        span{
          font-weight: var(--general-caption-font-weight);
          font-size: var(--general-caption-font-size);
          line-height: 18px;
          color: var(--font-color-blue002e5c);
        }
        }
    
`

export const ClassDescription = styled.div`
margin-top: 20px;
font-family: var(--general-font-family);
font-style: normal;
color: var(--font-color-blue002e5c);
span{
padding-bottom: 5px;
font-weight: var(--general-caption-font-weight);
font-size: var(--general-caption-font-size);
line-height: 50px;
}
p{
  margin-top: 20px;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 30px;
word-break: break-word;
p{
  span{
    font-size: var(--general-xlarge-body-font-size) !important;
  }
}
}
`
export const ClassSchedule = styled.div`
font-family: var(--general-font-family);
font-style: normal;
color: var(--font-color-blue002e5c);
span{
font-weight: var(--general-caption-font-weight);
font-size: var(--general-caption-font-size);
line-height: 18px;
text-transform: capitalize; 
 padding-bottom: 5px;
}
`
export const ScheduleList = styled.ul`
color: var(--font-color-blue002e5c);

list-style: none;
margin: 0;
padding: 0;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 26px;
li{
  span{
    font-weight: var(--general-sub-header-font-weight);
    font-size: var(--general-sub-header-font-size);

  }
}
`
export const Details = styled.ul`
list-style: none;
margin: 0;
padding: 0;
color: var(--font-color-blue002e5c);

li{
  display: flex;
  justify-content: space-between; 
  font-style: normal;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);
  line-height: 21px;
}
span{
  display: flex;
  justify-content: space-between; 
  font-style: normal;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);
  line-height: 21px;
  span{
    color: var(--font-color-blue002e5c);
    text-align: right;
    font-family: var(--general-small-header-font-family);
    font-size: var(--general-small-header-font-size);
    font-style: normal;
    font-weight: var(--general-small-header-font-weight);
    line-height: normal;
    text-transform: capitalize;
  }
 
}
`
export const TotalPay = styled.div`
  width: 543px;
    height: 59px;
    background: #EAEFF1;
    display: flex;
  justify-content: space-between; 
  align-items: center;
  font-weight: var(--font-weight-regular);
  font-size: var(--general-amount-font-size);
  line-height: 21px;
  padding-left: 48px;
  padding-right: 48px;
  margin-top: 33px;
  span{
    color: var(--font-color-blue002e5c);
    text-align: right;
    font-weight: var(--font-weight-bold);
    line-height: normal;
    text-transform: capitalize;
  }
`

export const Button = styled.div`
width: 100%;
display: flex;
justify-content: center;
position: absolute;
bottom: 0;

`
export const ClassButton = styled.button`
border: none;
background-color:${(props) => (props?.isAvailableClass ? 'gray' : '#2555EF')};
color: var(--font-color-white);
margin-bottom: 20px;
margin-top: 20px;
width: 100%;
height: 39px;
text-align: center;
display: flex;
justify-content: center;
align-items: center;
padding: 0;
border-radius: 5px;
`
export const AlreadyMember = styled.p`
text-align: center;
  color: var(--font-color-slate404253);
span{
  font-weight: var(--font-weight-bold);
  text-decoration: underline;
  cursor: pointer;
  color: var(--font-color-blue2555ef);
}
`

export const InfinitySymbol = styled.span`
    font-weight: var(--general-display-font-weight) !important;
    font-size: var(--general-display-font-size) !important;
    line-height: 32px !important;
    color: var(--font-color-blue2555ef) !important;
    font-family: var(--math-symbol-font-family) !important;
`

export const Note = styled.div`
  opacity: 0.7;
  color: var(--font-color-blue002e5c);
`